import contentumPreview from '../assets/contentum.png';
import { CreationType } from '../types/creation';
import { StrategyType } from '../constants/strategy';

// Define creation types with their corresponding strategy types and pro status
export const CREATION_TYPES: (CreationType & { comingSoon?: boolean })[] = [
  {
    id: 'c-roll',
    image: contentumPreview,
    price: 50,
    strategyType: StrategyType.KOVRIFICATION,
    proOnly: false
  },
  {
    id: 'podcast-series',
    image: contentumPreview,
    price: 60,
    strategyType: StrategyType.KOVRIFICATION,
    proOnly: true
  },
  {
    id: 'podcast-moments',
    image: contentumPreview,
    price: 12,
    pricingModel: '12/minute',
    strategyType: StrategyType.BEST_MOMENTS,
    proOnly: false
  },
  {
    id: 'ai-captions',
    image: contentumPreview,
    price: 30,
    strategyType: StrategyType.KOVRIFICATION,
    proOnly: false,
    comingSoon: true
  },
]; 